import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setBusy(true);
        try { await api.post("/auth/forgot-password", { email }); setDone(true); }
        catch (err) { toast.error(formatApiError(err)); }
        finally { setBusy(false); }
    }

    return (
        <div className="min-h-screen bg-[color:var(--gsf-green-900)] text-white flex items-center justify-center px-4" data-testid="forgot-password">
            <div className="w-full max-w-md">
                <div className="flex justify-center mb-8"><Logo variant="full" size={110} className="rounded-xl bg-white p-2" /></div>
                <div className="bg-white text-[color:var(--gsf-charcoal)] rounded-2xl p-8 shadow-2xl">
                    <div className="gsf-eyebrow">Password reset</div>
                    <h1 className="mt-2 font-serif text-2xl text-[color:var(--gsf-green-700)] font-bold">Forgot your password?</h1>
                    {done ? (
                        <p className="mt-4 text-sm text-gray-600" data-testid="forgot-done">
                            If an account exists for that address, a reset link has been sent. Please check your inbox
                            (and spam folder). The link expires in 1 hour.
                        </p>
                    ) : (
                        <form onSubmit={onSubmit} className="mt-6 space-y-4">
                            <div>
                                <label className="text-sm font-medium">Email</label>
                                <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"
                                    className="mt-1 w-full rounded-lg border border-gray-200 px-4 py-3 focus:outline-none focus:border-[color:var(--gsf-green-700)]" />
                            </div>
                            <button type="submit" disabled={busy} className="gsf-btn-primary w-full justify-center disabled:opacity-60" data-testid="forgot-submit">
                                {busy ? "Sending…" : "Send reset link"}
                            </button>
                        </form>
                    )}
                    <div className="mt-4 text-sm">
                        <Link to="/admin/login" className="text-[color:var(--gsf-green-700)] hover:underline" data-testid="forgot-back">Back to sign in</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
